import { ADMIN_ONLY } from "@/config";

/**
 * `(app)/_layout.tsx`'s `unstable_settings`, kept here so the web route context can give them to
 * Expo Router without downloading the vendor app (`src/lib/platform/webRouteContext.ts`).
 *
 * The admin build must not start on "(tabs)". expo-router keeps `anchor` at the bottom
 * of the stack, so the whole vendor app, with its chrome and queries, would mount beneath `/admin`.
 * Unit tests mock the stack and cannot catch this. `ADMIN_ONLY` is a build constant, so the choice
 * is fixed at module load.
 */
export const APP_GROUP_SETTINGS = { anchor: ADMIN_ONLY ? "admin" : "(tabs)" };
